<template>
  <DefaultLayout class="UserView">
    <UserDetails :user-id="userId" />
  </DefaultLayout>
</template>

<script>
import DefaultLayout from '../layouts/Default'
import UserDetails from '../components/UserDetails'

export default {
  name: 'User',
  components: {
    UserDetails,
    DefaultLayout,
  },
  props: {
    userId: { type: Number, required: true },
  },
  computed: {
    displayName() {
      const { $store, userId } = this
      return $store.getters['user/displayName'](userId)
    },
  },
  watch: {
    displayName: {
      handler(displayName) {
        document.title = `${displayName} – ${this.$const.APP_NAME}`
      },
      immediate: true,
    },
  },
}
</script>
